import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/node_modules/next/dist/client/link.js");
